var React                         = require("react");

var Card                          = require("patternity/lib/cards/card");
var InfiniteScroll                = require('patternity/lib/components/infinite_scroll');

var ExperienceCardContainer       = require("./experience_card_container");
var ChallengeCardContainer        = require("./challenge_card_container");
var ChannelCard                   = require("./channel_card");
var { withNamespaces }            = require('react-i18next');

var ChallengeCards = React.createClass({
  PropTypes : {
    challenges : React.PropTypes.array.isRequired,
    loadingChallenges : React.PropTypes.bool.isRequired,
    experiences : React.PropTypes.array.isRequired,
    channels : React.PropTypes.array.isRequired,
    hideCounters : React.PropTypes.bool,
    challengeActions : React.PropTypes.object.isRequired,
    challengeStage : React.PropTypes.string.isRequired,
    experiencePath : React.PropTypes.object.isRequired,
    channelPath : React.PropTypes.object.isRequired,
    fetchNextPageOfResults : React.PropTypes.func.isRequired,
    hasMoreChallenges : React.PropTypes.bool.isRequired,
    didTabsChange : React.PropTypes.bool.isRequired,
    retrieveChallengeStatusDescription : React.PropTypes.func.isRequired,
    challengeStatusDescription: React.PropTypes.object,
    pageThreshold: React.PropTypes.number.isRequired,
    homepageUrl: React.PropTypes.string.isRequired,
    shortCardDesignEnabled: React.PropTypes.bool,
    isUnlockable: React.PropTypes.bool
  },

  getDefaultProps: function() {
    return {
      challengeStatusDescription: {
        challengeId : null,
        statusDescription : ""
      }
    };
  },

  render : function(){
    return (
      <InfiniteScroll
          loadMore={this.props.fetchNextPageOfResults}
          hasMore={this.props.hasMoreChallenges}
          resetPageCount={this.props.didTabsChange}
          pageNumberStart={1}
          threshold={this.props.pageThreshold}>
        <Card.Container ref="challengeCardContainter">
          {this._buildExperienceCards()}
          {this._buildChannelCards()}
          {this._buildChallengeCards()}
        </Card.Container>

      </InfiniteScroll>
    );
  },

  _buildChannelCards: function () {
    if (this.props.challengeStage === "Available") {
      return this.props.channels.map(this._buildChannelCard);
    }
  },
  _buildChannelCard: function (channel) {
    var { hideCounters, channelPath, homepageUrl } = this.props;
    return (
      <ChannelCard
        key={`channel-container-${channel.id}`}
        channel={channel}
        hideCounters={hideCounters}
        channelPath={channelPath}
        homepageUrl={homepageUrl}
        shortCardDesignEnabled={this.props.shortCardDesignEnabled} />
    );
  },

  //TODO: START - Remove When Experiences Move To Sidebar
  _buildExperienceCards : function(){
    if(this.props.challengeStage === "Available"){
      return this.props.experiences.map(this._buildExperienceCard);
    }
  },
  _buildExperienceCard : function(experience) {
    var { hideCounters, experiencePath, homepageUrl } = this.props;
    return (
      <ExperienceCardContainer
        key={`experience-container-${experience.id}`}
        experience={experience}
        hideCounters={hideCounters}
        experiencePath={experiencePath}
        homepageUrl={homepageUrl}
        shortCardDesignEnabled={this.props.shortCardDesignEnabled} />
    );
  },

  _buildChallengeCards : function () {
    if (this.props.loadingChallenges) {
      return null;
    }

    var that = this;
    return this.props.challenges.map(function (pageChallenges){
      return pageChallenges.map(that._buildChallengeCard);
    });
  },

  _buildChallengeCard : function(challenge, index){
    return (
      <ChallengeCardContainer
        challenge={challenge}
        challengeActions={this.props.challengeActions}
        challengeStage={this.props.challengeStage}
        key={`challenge-container-${challenge.id}`}
        retrieveChallengeStatusDescription={this.props.retrieveChallengeStatusDescription}
        challengeStatusDescription={this.props.challengeStatusDescription}
        c2cfLabel={this.props.t('Homepage Challenge Card')}
        shortCardDesignEnabled={this.props.shortCardDesignEnabled}
        isUnlockable={this.props.isUnlockable} />
    );
  }
});

module.exports = {
  ChallengeCards: withNamespaces()(ChallengeCards)
};



// WEBPACK FOOTER //
// ./src/advocate/challenges/components/challenge_cards.jsx